// extracted by mini-css-extract-plugin
module.exports = {"container":"i_cU","title":"i_cV","labels":"i_cW","label":"i_cX","doughnuts":"i_cY"};